<template>
  <div class="d-flex align-items-center folder-item">
    <eg-icon
      :icon="item.icon"
      :class="{
        'folder-icon': true,
        'last-folder': !item?.children?.length,
      }"
    />
    <!-- TODO: detect if name truncated then show tooltip -->
    <div
      v-b-tooltip.hover="{ boundary: 'viewport' }"
      class="folder-name text-truncate mr-auto caption-s"
      :title="computedLabel"
    >
      {{ item.label }}
    </div>
    <!-- TODO: folder actions dropdown should be one, we just need to open it with selected folder -->
    <folder-actions-dropdown
      :folder-id="item.id"
      :workspace-key="workspaceKey"
      class="folder-actions-dropdown"
    >
      <template #button-content>
        <eg-b-button variant="none" size="sm" class="btn-action">
          <eg-icon icon="more-options-vertical-dots-dots" />
        </eg-b-button>
      </template>
    </folder-actions-dropdown>
  </div>
</template>

<script>
import FolderActionsDropdown from "@/components/global/folder_actions_dropdown.vue";

export default {
  name: "SidebarWorkspaceItem",
  components: {
    FolderActionsDropdown,
  },
  props: {
    item: {
      type: Object,
      required: true,
    },
    workspaceKey: {
      type: String,
      required: true,
    },
  },

  computed: {
    computedLabel() {
      // TODO: convert items of the workspace provider into objects with .isClass() and .isAssignment() methods
      if (
        (this.item.maxDepth === 3 && this.item.hierarchyLevel === 2) ||
        (this.item.maxDepth === 2 && this.item.hierarchyLevel === 1)
      ) {
        return `Class: ${this.item.label}`;
      }

      if (
        (this.item.maxDepth === 3 && this.item.hierarchyLevel === 3) ||
        (this.item.maxDepth === 2 && this.item.hierarchyLevel === 2)
      ) {
        return `Assignment: ${this.item.label}`;
      }

      // display nothing for the top level of 3-levels hierarchy
      return undefined;
    },
  },
};
</script>

<style scoped lang="scss">
.folder-item {
  width: 100%;
  display: flex;
  align-items: center;
  color: hsl(208deg, 7%, 46%);
  gap: 8px;
  overflow: hidden;
}

.folder-name {
  color: var(--color-text-neutral-on-white, #1c0f30);
}

.folder-actions-dropdown::v-deep {
  .btn {
    padding: 0;
  }
}

.btn-action {
  padding: 0 5px;
  opacity: 0;
}
</style>
